module.exports = __webpack_public_path__ + "static/media/sampler.d075d757.svg";